import { useVenueDataContext } from '@/VenueDataLoader'

export function useVenue() {
  const { venueInfo } = useVenueDataContext()
  return venueInfo
}
